import { NgxPermissionsModule } from 'ngx-permissions';
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Angular Material
import {
  MatButtonModule,
  MatProgressBarModule,
  MatTabsModule,
  MatTooltipModule,
  MatFormFieldModule,
} from '@angular/material';
// NgBootstrap
import {
  NgbDropdownModule,
  NgbProgressbarModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
// Translation
import { TranslateModule } from '@ngx-translate/core';
// Loading bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Ngx DatePicker
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
// Core Module
import { CoreModule } from '../../core/core.module';
import { HeaderComponent } from './header/header.component';

import { NavbarComponent } from './navbar/navbar.component';

import { AsideLeftComponent } from './aside/aside-left.component';
import { FooterComponent } from './footer/footer.component';

import { SubheaderComponent } from './subheader/subheader.component';
import { BrandComponent } from './brand/brand.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { MenuHorizontalComponent } from './header/menu-horizontal/menu-horizontal.component';
import { PartialsModule } from '../partials/partials.module';
import { BaseComponent } from './base/base.component';
import { PagesModule } from '../pages/pages.module';

import { HtmlClassService } from './html-class.service';
import { HeaderMobileComponent } from './header/header-mobile/header-mobile.component';
import { ErrorPageComponent } from './content/error-page/error-page.component';
import { PermissionEffects, permissionsReducer, RoleEffects, rolesReducer } from '../../core/auth';
import { BaseAdminComponent } from './base-admin/base-admin.component';
import { AdminPageModule } from '../pages/admin-page/admin-page.module';
// Snow Effect
import { SnowEffectModule } from '../../components/snow-effect/snow-effect.module';
//bl
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../shared/shared.module';
import { FooterComponent2 } from './footer2/footer2.component';
import { MobileBottonNavComponent } from './mobile-botton-nav/mobile-botton-nav.component';
import { NotificationStateService } from '../../services/notification-state.service';
import { SignalRService } from '../../services/signalr.service';
//end bl

@NgModule({
  declarations: [
    BaseComponent,
    FooterComponent,
    FooterComponent2,
    // headers
    HeaderComponent,
    BrandComponent,
    HeaderMobileComponent,

    //NavbarComponent
    NavbarComponent,

    // subheader
    SubheaderComponent,

    // topbar components
    TopbarComponent,

    // aside left menu components
    AsideLeftComponent,

    // horizontal menu components
    MenuHorizontalComponent,

    ErrorPageComponent,

    BaseAdminComponent,

    MobileBottonNavComponent,
  ],
  exports: [
    BaseComponent,
    BaseAdminComponent,
    FooterComponent,
    FooterComponent2,
    // headers
    HeaderComponent,
    BrandComponent,
    HeaderMobileComponent,

    //NavbarComponent
    NavbarComponent,

    // subheader
    SubheaderComponent,

    // topbar components
    TopbarComponent,

    // aside left menu components
    AsideLeftComponent,

    // horizontal menu components
    MenuHorizontalComponent,

    ErrorPageComponent,

    RouterModule,

    MobileBottonNavComponent,
  ],
  providers: [HtmlClassService, NotificationStateService, SignalRService],
  imports: [
    CommonModule,
    RouterModule,
    NgxPermissionsModule.forChild(),
    StoreModule.forFeature('roles', rolesReducer),
    StoreModule.forFeature('permissions', permissionsReducer),
    EffectsModule.forFeature([PermissionEffects, RoleEffects]),
    PagesModule,
    AdminPageModule,
    PartialsModule,
    CoreModule,
    PerfectScrollbarModule,
    FormsModule,
    MatProgressBarModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule.forChild(),
    LoadingBarModule,
    NgxDaterangepickerMd,
    InlineSVGModule,

    // ng-bootstrap modules
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    MatIconModule,
    MatRadioModule,
    // Snow Effect Module
    SnowEffectModule,
    //bl
    ReactiveFormsModule,
    MatFormFieldModule,
    SharedModule,
    //endbl
  ],
  entryComponents: [],
})
export class ThemeModule {}
